import { REACT_QUERY_KEYS, bridgeRequest } from 'common'
import { GetReportsHistoryResponse } from 'common/types'
import { TEndpoint, TEntity } from 'contexts/app-context/types'

import { queryOptions } from '@tanstack/react-query'

import { GetUnderAnalysisReportsResponse } from '../../types/YourPersonalData.types'

interface GetReportsUnderAnalysisQueryParams {
  endpoint?: TEndpoint
  userCountry?: string
  userSelectedEntity?: TEntity
  isUSBranch: boolean
}

export const getReportsUnderAnalysisQueryKey = ({
  userCountry,
  userSelectedEntity,
}: Pick<GetReportsUnderAnalysisQueryParams, 'userCountry' | 'userSelectedEntity'>) => [
  REACT_QUERY_KEYS.REPORTS_IN_ANALYSIS,
  userCountry,
  userSelectedEntity,
]

export const getReportsUnderAnalysisQueryOptions = ({
  endpoint,
  userCountry,
  userSelectedEntity,
  isUSBranch,
}: GetReportsUnderAnalysisQueryParams) =>
  queryOptions({
    queryKey: getReportsUnderAnalysisQueryKey({ userCountry, userSelectedEntity }),
    queryFn: () => {
      if (!endpoint) throw new Error('No get reports under analysis endpoint available')

      return bridgeRequest<GetReportsHistoryResponse | GetUnderAnalysisReportsResponse>({
        endpoint,
        returnAllResponse: false,
        isUSBranch,
      })
    },
    enabled: !!endpoint && !!userCountry && !!userSelectedEntity,
    staleTime: 1000 * 60 * 10,
    gcTime: 1000 * 60 * 30,
  })
